import * as requestFromServer from "./importMutationBankCrud";
import { importMutationBankSlice, callTypes } from "./importMutationBankSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = importMutationBankSlice;

export const fetchImportMutationBanks = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findImportMutationBank(queryParams)
    .then((response) => {
      const {
        data: { total_items, items },
      } = response.data;
      dispatch(actions.importMutationBanksFetched({ total_items, items }));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchImportMutationBank = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.importMutationBankFetched({
        importMutationBankForEdit: undefined,
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getImportMutationBankById(id)
    .then((response) => {
      const { data: importMutationBank } = response.data; // alias data -> donatur
      dispatch(
        actions.importMutationBankFetched({
          importMutationBankForEdit: importMutationBank,
        })
      );
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createImportMutationBank = (importMutationBankForCreation) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createImportMutationBank(importMutationBankForCreation)
    .then((response) => {
      dispatch(actions.importMutationBankReload);
      toast.success(response.data.message, toastOption);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const proccessImportMutationBank = (importMutationBank) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .proccesImportMutationBank(importMutationBank)
    .then((response) => {
      dispatch(actions.importMutationBankReload);
      return response.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
